import { useMemo, useCallback } from 'react';
import dayjs from '@/utils/dayjsConfig';
import { useTranslation } from 'react-i18next';
import { MONTH_FORMAT, divClass } from '@/enums/pageEnum';

export const useUtilsMemo = () => {
  const { t } = useTranslation();
  const previousMonth = useMemo(() => {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth() - 1, 1);
  }, []);

  const monthObj = useCallback(
    (change: (date: Date) => void) => {
      return {
        component: 'monthDate' as const,
        field: 'month',
        label: t('month'),
        fieldProps: {
          maxDate: dayjs(previousMonth),
          format: MONTH_FORMAT,
          style: { width: '230px' },
          divClass,
          allowClear: false,
          onChange: (date: Date) => {
            change(date);
          },
        },
      };
    },
    [t, previousMonth],
  );

  return {
    previousMonth,
    monthObj,
  };
};

export default useUtilsMemo;
